import marketingInstance from './instance'

const storeCoupon = (data) => {
  return marketingInstance.post('/coupons', data)
}

export default storeCoupon
